import Label from './Label';

export { LabelKind } from './Label';
export default Label;
